import {ChangeDetectorRef, Component} from "@angular/core";
import {provideEntityModel} from "@fedeltapointofsale/data-client";
import {CustomObjectEditPageComponent} from "./custom-object-edit-page.component";
import {InventoryCustomObjectEntityModel} from "../inventory-custom-object-entity.model";
import {FUIResponsiveService} from "@fedeltapointofsale/ui";

@Component({
    selector: "wbo-inventory-custom-object-edit-page",
    templateUrl: "./custom-object-edit-page.component.html",
    providers: [provideEntityModel(InventoryCustomObjectEntityModel)]
})
export class InventoryCustomObjectEditPageComponent extends CustomObjectEditPageComponent {
    override inventoryContext: boolean = true;

    constructor(model: InventoryCustomObjectEntityModel,
                changeDetectorRef: ChangeDetectorRef,
                responsiveService: FUIResponsiveService) {
        super(model, changeDetectorRef, responsiveService);
    }
}
